/* eslint-disable */
import {
  Layout,
  Divider,
  Row,
  Col,
  Button,
  Alert,
  List,
  Tooltip,
  Spin,
  Table,
  Typography,
  Modal,
  Form,
  Input,
  Icon
} from "antd";
import React from 'react';
import { connect } from "react-redux";
import { Constant } from "../../../config";
import axios from "axios";
import { debounce } from "lodash";
import { setRevisionPriceStep, setRevisionLogs } from '../../../store/actions/revisionPrice';

const { Text } = Typography;

class ReviseSellPrice extends React.Component  {
  state = {
    loading: false,
    hasMore: true,
    page: 1,
    selectedCountry: {},
    enableReviseModal: false,
    revisionLogs: [],
    countryListData: [],
    revisionRate: [],
    revisionRateTemp: [],
    isCreateRevision: true,
    isEditReviseLogs: false
  };
  
  columns = [
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
      render: (text, record, index) => {
        return <span>{index + 1}. {record.country_name || '-'}</span>
      },
      align: 'center',
    },
    {
      title: 'New Rate',
      dataIndex: 'new_rate',
      key: 'new_rate',
      render: (text, record) => {
        return <span>{record.price.toFixed(4)} <Icon type="arrow-right" /> {record.new_rate}</span>
      },
      align: 'center',
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => {
        return (
          <div>
            <Tooltip placement="top" title="Edit">
              <Button shape="circle" size="small" icon="edit" onClick={() => this._editRevisePriceLogs(record)} />&nbsp;
            </Tooltip>
            <Tooltip placement="top" title="View">
              <Button shape="circle" size="small" icon="delete" onClick={() => this._delRevisePriceLogs(record)} />
            </Tooltip>
          </div>
        );
      },
      align: 'center',
    },
  ];

  componentWillMount() {
    if (this.props.revisionId !== -1) {
      this.setState({
        revisionId: this.props.revisionId,
        isCreateRevision: false
      })
    }
    this.setState({
      revisionRate: this.props.revisionRate,
      loading: true
    })
  }

  async componentDidMount() {
    await this._fetchCountryList(),
    this.setState({
      revisionLogs: this.props.revisionLogs,
      loading: false
  	})
  }

  _prevStep = () => {
    this.props.setRevisionPriceStep({
      step: 0
    })
  }

  _nextStep = () => {
    if (this.state.revisionLogs.length === 0 ) return;
    this.props.setRevisionLogs({
      logs: this.state.revisionLogs
    })
    this.props.setRevisionPriceStep({
      step: 2
    })
  }

  _fetchCountryList = async (page=1, limit=-1)=>{
  	let url = Constant.COUNTRY_API+"?page="+page+"&limit="+limit;

    let opt = {
      url,
      method: "GET",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    let data = resp.data.data
    if (data) {
      let { revisionRate } = this.state;
      revisionRate.map((p) => {
        const country = data.find((c) => {
          return p.country_abbr === c.region_code;
        })
        p.country_name = country.name;
      })
      this.setState({
        revisionRate,
        revisionRateTemp: revisionRate
      })
    }
  }

  _revisePrice = (contry) => {
    this.props.form.setFieldsValue({
      old_rate: contry.price.toFixed(4),
      new_rate: null
    });
    this.setState({
      selectedCountry: contry,
      enableReviseModal: true
    })
  }

  _editRevisePriceLogs = (contry) => {
    this.setState({isEditReviseLogs: true})
    this.props.form.setFieldsValue({
      old_rate: contry.price.toFixed(4),
      new_rate: contry.new_rate
    });
    this.setState({
      selectedCountry: contry,
      enableReviseModal: true
    })
  }

  _delRevisePriceLogs = (contry) => {
    let { revisionLogs } = this.state;
    const index = revisionLogs.map(object => object.id).indexOf(contry.id);
    revisionLogs.splice(index, 1);
    this.setState({revisionLogs})
    this.props.setRevisionLogs({
      logs: revisionLogs
    })
  }

  _onCancelRevise = () => {
    this.setState({
      selectedCountry: {},
      enableReviseModal: false
    })
  }

  _onConfirmRevise = () => {
    this.props.form.validateFields(async (err, values) => {
      if (err) return;

      let { new_rate } = values;
      let { revisionLogs, selectedCountry } = this.state;
      if (this.state.isEditReviseLogs) {
        revisionLogs = revisionLogs.map(object => {
          if (object.id === selectedCountry.id) {
            return {...object, new_rate: parseFloat(new_rate).toFixed(4)};
          }
          return object;
        });
      } else {
        selectedCountry.new_rate = parseFloat(new_rate).toFixed(4);
        revisionLogs = revisionLogs.concat([selectedCountry])
      }
      this.setState({revisionLogs, enableReviseModal: false, isEditReviseLogs: false})
      this.props.setRevisionLogs({
        logs: revisionLogs
      })
    })
  }

  _onSearchCountry = (event) => {
    event.persist();
    this.setState({
      loading: true,
    });

    if (!this.debouncedFn) {
      this.debouncedFn = debounce(() => {
        const c = event.target.value;
        if (c.length === 0) {
          this.setState({
            revisionRate: this.state.revisionRateTemp,
          });
        }

        const filteredCountry = this.state.revisionRate.filter((country) =>
          country["country_name"].toLowerCase().includes(c.toLowerCase())
        );

        this.setState({
          revisionRate: filteredCountry,
          loading: false,
        });
      }, 600);
    }

    this.debouncedFn();
  };

  _hasRevised = (id) => {
    const logs = this.state.revisionLogs.find(element => {
      return element.id === id
    }); 
    return logs === undefined
  }

  _descRenderer() {
    const txt = 'will update and save changes log compare to'
    let descTxt = ''
    if (this.state.isCreateRevision) {
      descTxt = `New revision ${txt} [${this.props.revisionNextInfo.name} - ${String(this.props.revisionNextInfo.version).padStart(4, "0")}]`

    } else {
      descTxt = `Revision Edit ${txt} [${this.props.revisionInfo.name} - ${String(this.props.revisionInfo.version).padStart(4, "0")}]`     
    }

    return descTxt;
  }
  
  render() {
    const { getFieldDecorator } = this.props.form;
    let propsTable = {
      columns: this.columns,
      dataSource: this.state.revisionLogs,
      rowKey: (record) => record.id,
      pagination: false,
    };

    return (
      
      <Layout className="section-layout">
        <Divider />
        <Row type="flex" gutter={20} align="middle" style={{marginBottom: 20}}>
          <Col span={6} className="text-right font-bold">Price Revision</Col>
          <Col span={18}>
            <Alert
              message=""
              description={this._descRenderer()}
              type="info"
            />
          </Col>
        </Row>
        <Row gutter={20}>
          <Col xs={{span: 24}} sm={{span: 14}}>
            <div style={{ marginBottom: 15 }}>
              <Input
                style={{ width: '150px' }}
                prefix={<Icon type="search" />}
                placeholder="Search Country"
                onChange={this._onSearchCountry}
              />
            </div>
            <div className="revise-country-wrap">
              <Row type="flex" className="revise-country-header">
                <Col span={8} className="text-center">Country</Col>
                <Col span={8} className="text-center">Client Rate (Version-{this.state.isCreateRevision ? String(this.props.revisionNextInfo.version).padStart(4, "0") : String(this.props.revisionInfo.version).padStart(4, "0")})</Col>
                <Col span={8} className="text-center">Action</Col>
              </Row>
              <div className="revise-country">
                <Spin spinning={this.state.loading}>
                  <List
                    dataSource={this.state.revisionRate}
                    renderItem={item => (
                      <List.Item key={item.id}>
                        <Row type="flex">
                          <Col span={8} className="text-center" style={{fontWeight: 'bold'}}>{item.country_name}</Col>
                          <Col span={8} className="text-center">{item.price.toFixed(4)}</Col>
                          <Col span={8} className="text-center">{this._hasRevised(item.id) && (<div className="text-link" onClick={() => this._revisePrice(item)}>Revise Price</div>)}</Col>
                        </Row>
                      </List.Item>
                    )}
                  >
                  </List>
                </Spin>
              </div>
              {this.state.hasMore && (
                <Text type="secondary" className="text-scroll">Scroll for more</Text>
              )}
            </div>
          </Col>
          <Col xs={{span: 24}} sm={{span: 10}}>
            <div className="revision-logs-title">Revision Logs</div>
            <Table className="revision-table" {...propsTable} scroll={{ y: 320 }}></Table>
          </Col>
        </Row>
        <Divider />
        <div className="steps-action">
          <Row type="flex" gutter={20} align="middle">
            <Col span={12} className='text-right'>
              <div className="step-link" onClick={() => this._prevStep()}>
                Back
              </div>
            </Col>
            <Col span={12}>
              <Button type="primary" onClick={() => this._nextStep()} disabled={this.state.revisionLogs.length === 0}>
                Next
              </Button>
            </Col>
          </Row>
        </div>
        <Modal
          visible={this.state.enableReviseModal}
          title={`Revision Price: ${this.state.selectedCountry.country_name}`}
          okText={"Confirm"}
          cancelText="Cancel"
          onCancel={this._onCancelRevise}
          onOk={this._onConfirmRevise}
          maskClosable={false}
          style={{ top: 50 }}
        >
          <Form layout="vertical">
            <Form.Item label="Old Rate (Version 0000)">
              {getFieldDecorator('old_rate')(<Input disabled />)}
            </Form.Item>
            <Form.Item label="New Rate">
              {getFieldDecorator('new_rate', {
                rules: [
                  {
                    pattern: new RegExp("^[0-9]+([.][0-9]{1,4})?$"),
                    message: "กรุณากรอกเป็นตัวเลขและเลขทศนิยมได้ไม่เกิน 4 ตัวเท่านั้น"
                  },
                  { required: true, message: 'กรุณากรอก New Rate' }],
              })(<Input />)}
            </Form.Item>
          </Form>
        </Modal>
      </Layout>
    )
  }
}

const mapStateToProps = state => {
	return {
		revisionId: state.revisionPrice.id,
    revisionRate: state.revisionPrice.rate,
    revisionInfo: state.revisionPrice.info,
    revisionLogs: state.revisionPrice.logs,
    revisionNextInfo: state.revisionPrice.nextInfo,
	}
}


const mapDispatchToProps = dispatch => {
	return {
    setRevisionPriceStep: ({step}) => dispatch(setRevisionPriceStep({step})),
    setRevisionLogs: ({logs}) => dispatch(setRevisionLogs({logs}))
	}
}

const ReviseSellPriceForm = Form.create({ name: "revise-sell-price" })(ReviseSellPrice)

export default connect(mapStateToProps, mapDispatchToProps)(ReviseSellPriceForm);


// WEBPACK FOOTER //
// ./src/containers/RevisionPrice/steps/stepTwo.js